import type { DeploymentBrandingSettings } from "@yazamco/shared-types";

interface BrandingPayload {
  branding: DeploymentBrandingSettings | null;
}

async function brandingRequest(
  method: "GET" | "PUT",
  body?: Omit<DeploymentBrandingSettings, "updatedAt">,
): Promise<BrandingPayload> {
  const response = await fetch("/api/v1/settings/branding", {
    method,
    headers: body ? { "content-type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = (await response.json().catch(() => ({}))) as BrandingPayload & {
    error?: { message?: string };
  };
  if (!response.ok) {
    throw new Error(payload.error?.message ?? `Branding request failed (${response.status}).`);
  }
  return payload;
}

export const fetchDeploymentBranding = (): Promise<BrandingPayload> =>
  brandingRequest("GET");

export const updateDeploymentBranding = (
  branding: Omit<DeploymentBrandingSettings, "updatedAt">,
): Promise<BrandingPayload> => brandingRequest("PUT", branding);
